export default __webpack_public_path__ + "a56369fde9a16a16fca2ca2015101d99.png";